import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
 * {
     font-family: 'Poppins', sans-serif;
 }
`;
